import { loader } from 'graphql.macro'
import { intercomConnection } from '../../intercomConnection'

export default async function updateHaulerDetails ({ dataLoaders, variables }) {
  const schema = loader('./updateHauler.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  intercomConnection.trackEvent('hauler_updated')
  return response.updateHauler
}
